<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Convenios</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_accion">
            <div>
                <v-text-field
                    v-model="searchConvenios"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                    :disabled="isLoading"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    :disabled="isLoading"
                    @click="getAgreementList()"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            :headers="dataSourceConvenios.headers"
            :items="dataSourceConvenios.data"
            :search="searchConvenios"
            :loading="isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        >
            <template v-slot:[`item.actions`]="{ item }">
                <td>
                    <v-tooltip text="Eliminar Convenio" location="bottom" v-if="!item.validado">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0 mr-1"
                                density="comfortable"
                                icon="mdi-delete"
                                color="error"
                                @click="confirmateDeteleAgreements(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>

                    <v-tooltip text="Reasignar" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0 mr-1"
                                density="comfortable"
                                icon="mdi-wrench"
                                color="indigo-darken-3"
                                @click="openDialog(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>

    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información de los Convenios</div>
    </div>

    <template>
      <v-dialog v-model="dialogDelete.open" width="500px" persistent>
          <v-card>
              <v-card-title>
                  <span class="text-h5">Confirmación</span>
              </v-card-title>
              <v-card-text>
                <div v-if="!dialogDelete.loading">
                  <div class="text-center">
                      <img src="@/assets/images/warning.png">
                  </div>
                  <div class="description-text">
                      <p>¿Está seguro de eliminar el convenio??</p>
                  </div>
                </div>
                <div class="content_load" v-if="dialogDelete.loading">
                  <v-progress-circular
                    :size="100"
                    :width="7"
                    color="indigo-darken-3"
                    indeterminate
                  ></v-progress-circular>
                  <i>Espere un momento</i>
                  <div>Eliminando el convenio</div>
                </div>
              </v-card-text>
              <v-card-actions class="actions_buttons" v-if="!dialogDelete.loading">
                  <v-btn 
                    variant="flat"
                    class="text-none"
                    color="red"
                    @click="dialogDelete.open = false"
                    text="Cancelar"
                ></v-btn>
                <v-btn 
                    variant="flat"
                    class="text-none"
                    color="indigo-darken-3"
                    @click="deleteAgreements()" 
                    :loading="dialogDelete.loading"
                    text="Aceptar"
                ></v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </template>

    <template>
      <v-dialog v-model="dialogReasignar" width="500px" persistent>
          <v-card>
                <v-card-title>
                  <span class="text-h5">Reasignar</span>
                </v-card-title>
                <v-card-text>
                    <label>Usuarios</label>
                    <v-select prepend-inner-icon="mdi-magnify" placeholder="Seleccione uno..."
                    v-model="userManagerType" :items="listUserManagerType" variant="outlined"
                    item-title="fullName" item-value="id">                    
                    </v-select>
                
                </v-card-text>
                <v-card-actions class="actions_buttons">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogReasignar = false"
                        text="Cancelar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="reasignarUser()"                         
                        text="Reasignar"
                    ></v-btn>
                </v-card-actions> 
          </v-card>
      </v-dialog>
    </template>

    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService';
import { ManagementsService } from '@/services/ManagementsService';
import { ResourcesService } from '@/services/ResourcesService';
import SnackbarComponent from '@/components/Snackbar'
import { useUiStore } from '@/stores/ui'
export default {
    name: "AgreementsView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            searchConvenios: '',
            isLoading: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            idClient: null,
            dataSourceConvenios: {
                data: [],
                headers: [
                    {
                        align: "start",
                        key: "folio",
                        title: "Folio",
                    },
                    { key: "estado", title: "Estado" },
                    { key: "numero_pagos", title: "Número de Pagos" },
                    { key: "pago_inicial", title: "Pago Inicial" },
                    { key: "saldo_plan", title: "Saldo del Plan" },
                    { key: "username", title: "Gestor" },
                    { key: "por_pagar", title: "Por Pagar" },
                ],
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
            dialogDelete: {
                id: null,
                tipo_convenio: null,
                open: false,
                loading: false,
            },
            dialogReasignar: false,
            idConvenio: '',
            listUserManagerType:[],
            userManagerType: null,
        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
    },
    async mounted() {
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created() {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id;

        const ENC_TIPO = localStorage.getItem('TIPO')
        const TIPO = await EncryptService.decrypt(ENC_TIPO)
        if (TIPO === 'Administrador') {
            this.dataSourceConvenios.headers.push({
                key: "actions", title: "Acciones"
            });
        }

        this.isLoading = true
        await this.getClientInformation()
        await this.getAgreementList()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {                    
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getAgreementList: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getAgreementList(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        for (let index = 0; index < responseData.response.length; index++) {
                            let element = responseData.response[index];
                            element.pago_inicial = ResourcesService.moneyFormat(parseInt(element.pago_inicial))
                            element.saldo_plan = ResourcesService.moneyFormat(parseInt(element.saldo_plan))
                            element.por_pagar = ResourcesService.moneyFormat(parseInt(element.por_pagar))
                            responseData.response[index] = element
                        }
                        this.dataSourceConvenios.data = responseData.response

                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        confirmateDeteleAgreements: function (item) {
            this.dialogDelete.id = item.id;
            this.dialogDelete.tipo_convenio = item.tipo_convenio;
            this.dialogDelete.open = true;
        },
        deleteAgreements: async function () {
            this.dialogDelete.loading = true;

            const ID = this.dialogDelete.id.toString();
            const TIPO_CONVENIO = this.dialogDelete.tipo_convenio.toString();

            const ENC_ID = await EncryptService.encrypt(ID);
            const ENC_TIPO_CONVENIO = await EncryptService.encrypt(TIPO_CONVENIO);

            await ManagementsService.cancelAgreement(ENC_ID, ENC_TIPO_CONVENIO).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = "¡Eliminación de Convenio Exitosa!"
                        this.snackbarData.openSnackbar = true;

                        this.getAgreementList();
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            );
            this.dialogDelete.open = false;
            this.dialogDelete.loading = false;
        },
        openDialog: async function(item){
            this.dialogReasignar = true;
            this.idConvenio = item.id;            
            await ManagementsService.getUsersManagers().then(
                (resp) => {
                    if(!resp.error){
                        for (let element of resp.response) {
                            element.fullName = `${element.name} ${element.last_name} (${element.username})`;
                        }
                        this.listUserManagerType = resp.response;

                    }
                }
            );
        },
        reasignarUser: async function(){
            this.isLoading = true
            
            let idConvenio = await EncryptService.encrypt(String(this.idConvenio));
            let idUser = await EncryptService.encrypt(String(this.userManagerType));
            
            const REQUEST_FORM = {
                id_usuario: idUser,
                id_convenio:idConvenio
            }
            
            await ManagementsService.changeAccount(REQUEST_FORM).then(
                (responseData) =>{                    
                    if(!responseData.error){
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                        this.getAgreementList();
                    }
                }
            );
            this.dialogReasignar = false;
            this.userManagerType = null;
            this.idConvenio = '';
            this.isLoading = false;
        }
    },
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }
    
</style>